import React from 'react';
import PropTypes from 'prop-types';
import LinkItem from './LinkItem';
import s from './Linkitem.scss';

const getGAData = (gaData, index) => {
  if (!gaData || typeof gaData !== 'string') {
    return '';
  }

  const updatedGAData = gaData.replace('$index', index);
  return updatedGAData;
};

const renderData = (
  item,
  showIcon,
  htmlKeys,
  itemWrapperClass,
  index,
  restProps,
) => {
  // eslint-disable-next-line no-param-reassign
  restProps.newGA = getGAData(`${restProps.newga}${item.wu}`, index + 1);

  return itemWrapperClass ? (
    <div className={itemWrapperClass}>
      <LinkItem
        item={item}
        showIcon={showIcon}
        htmlKeys={htmlKeys}
        {...restProps}
        key={item.wu}
        className={`${restProps.className} ${
          item.tn === 'liveblog' ? s.lbBlinker : ''
        }`}
        gaIndex={index + 1}
      />
    </div>
  ) : (
    <LinkItem
      item={item}
      showIcon={showIcon}
      htmlKeys={htmlKeys}
      {...restProps}
      key={item.wu}
      className={`${restProps.className} ${
        item.tn === 'liveblog' ? s.lbBlinker : ''
      }`}
      gaIndex={index + 1}
    />
  );
};

export default function LinkList(props) {
  const {
    data = [],
    listWrapperClass,
    itemWrapperClass,
    showIcon,
    htmlKeys,
    ...restProps
  } = props;
  if (!(data instanceof Array)) {
    return null;
  }

  if (listWrapperClass) {
    return (
      <div className={listWrapperClass}>
        {data.map((item, index) =>
          renderData(
            item,
            showIcon,
            htmlKeys,
            itemWrapperClass,
            index,
            restProps,
          ),
        )}
      </div>
    );
  }

  return data.map((item, index) =>
    renderData(item, showIcon, htmlKeys, itemWrapperClass, index, restProps),
  );
}
LinkList.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
